export default __webpack_public_path__ + "static/media/powerHold.06db759f.svg";